// Shared weekday helpers for the schedule UI.

export const WEEKDAYS_RU = [
  { iso: 1, short: 'Пн' },
  { iso: 2, short: 'Вт' },
  { iso: 3, short: 'Ср' },
  { iso: 4, short: 'Чт' },
  { iso: 5, short: 'Пт' },
  { iso: 6, short: 'Сб' },
  { iso: 7, short: 'Вс' },
] as const;

export function joinDays(days: number[]): string {
  if (!days.length) return '—';
  return WEEKDAYS_RU
    .filter((w) => days.includes(w.iso))
    .map((w) => w.short)
    .join(', ');
}

/** Format an ISO MSK datetime (e.g. 2026-05-18T10:00:00+03:00) for human eyes. */
export function fmtMskHuman(iso: string | null): string {
  if (!iso) return '—';
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(iso);
  if (!m) return iso;
  const [, y, mo, d, h, mi] = m;
  const day = WEEKDAYS_RU[(new Date(Number(y), Number(mo) - 1, Number(d)).getDay() + 6) % 7].short;
  return `${day} ${d}.${mo}.${y} ${h}:${mi}`;
}
